// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__8Pn5p","title":"ClientReferral_title__3RsWq","itemText":"ClientReferral_itemText__uqqm0"};